import { SearchScenarioId } from "../store/schema/SearchScenarioId";
import type { TraceErrorObject } from "owa-analytics-types";

/**
 * Converts given scenarioId to a string (to be used as map key).
 * @param scenarioId ID representing search scenario
 */
export default function getScenarioIdKey(scenarioId: SearchScenarioId): string {
    switch (scenarioId) {
        case SearchScenarioId.Mail:
            return "Mail";
        case SearchScenarioId.Calendar:
            return "Calendar";
        case SearchScenarioId.GroupsMail:
            return "GroupsMail";
        case SearchScenarioId.People:
            return "People";
        default:
            const err: TraceErrorObject = new Error("Unknown SearchScenarioId value!");
            err.additionalInfo = { searchScenarioId: scenarioId };
            throw err;
    }
}
